// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';

// img
import singleDownloadImg from '../img/download_img.png';

function Gaap02(){
    window.scrollTo(0,0);
    return (
        <div className="content">
            <h2 className="content_title">Error correction & Removing duplicate reads</h2>
            <div className="content_text">
                After sequencing has been completed, read sequence data and information
                about quality are conveyed to the user in a text file using FASTQ format.
                However, raw read data typically include numerous errors from the sequencing process;
                therefore, these errors need to be removed by the correction process.
            </div>
            <div className="content_text">
                GAAP uses SOAPec, which is a k-mer-based error correction tool.
            </div>
            <div className="content_command_title">SOAPec</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://sourceforge.net/projects/soapdenovo2/files/ErrorCorrection" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">SOAPec Command</li>
            <div className="content_text">
                The error correction process consists of two stages: 
                first, k-mer frequency spectrum is generated by running 
                KmerFreq_AR on readlist.txt next; next, errors are corrected 
                by running Corrector_AR.
            </div>
            <CommandBox lines={[
                {data:'KmerFreq_AR -k 17 -t 10 -p prefix readlist.txt'},
                {data:'Corrector_AR -k 17 -l 3 -r 50 -t 10 prefix.freq.cz prefix.freq.cz.len readlist.txt'},
            ]}
            /><br/>
            <li className="content_description">Options for KmerFreq_AR</li>
            <OptionTable
                data={
                    [
                        {   option:'-k',
                            desc:'specify the k-mer size'},
                        {   option:'-t',
                            desc:'specify the thread count'},
                        {   option:'-p',
                            desc:'specify the prefix of the output file'}
                    ]
                }
            /><br/>
            <li className="content_description">Output of KmerFreq_AR</li>
            <div className="content_text">
                prefix.freq.cz : K-mer frequency file<br />
                prefix.freq.cz.len : data on the length of each block in the K-mer frequency file<br/>
                prefix.freq.stat : statistical information about K-mer frequency<br/><br/>
            </div>
            <li className="content_description">Options for Corrector AR</li>
            <OptionTable
                data={[     
                        {   option:'-k',
                            desc:'specify the k-mer size'},
                        {   option:'-l',
                            desc:'specify the cutoff size for removing low-frequency K-mers'},
                        {   option:'-r',
                            desc:'specify the minimum length of reads'},
                        {   option:'-t',
                            desc:'specify the thread count'},
                ]}
            /><br/>
            <li className="content_description">Output of Corrector_AR</li>
            <div className="content_text">
            *.cor.pair_*.fq : paired-end-reads and newly refind reads <br/>
            *.cor.stat: statistical information <br/>
            readlist.txt.QC.xls : information on the read quility control <br/>
            </div><br/>
            <div className="content_command_title">Picard</div><br/>
            <div className="content_text">
                In order to improve the accuracy of assembly and annotation, GAAP uses Picard to remove duplicate reads<br/>
            </div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://broadinstitute.github.io/picard" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">FastqToSam Command</li>
            <div className="content_text">
                FastqToSam is used to convert the error-corrected FASTQ file, prefix.fq, into a SAM/BAM file.<br/>
            </div>
            <CommandBox lines={[
                {data:'java -jar picard.jar FastqToSam F1=forward_reads.fq F2=reverse_reads.fq'},
                {data:'O=unaligned_read_pairs.sam SM=sample001'},
            ]}
            /><br/>
            <li className="content_description">Options for FastqToSam</li>
            <OptionTable
                data={[
                    {   option:'F1, F2',
                        desc:'specify the paired-end read files'},
                    {   option:'O',
                        desc:'specify the output SAM / BAM file'},
                    {   option:'SM',
                        desc:'specify the samples name to be inserted into the header of the SAM'},
                ]}
            /><br />
            <li className="content_description">Markduplicates Command</li>
            <div className="content_text">
                Markduplicates is used to remove duplicate reads.<br/>
            </div>
            <CommandBox lines={[
                {data:'java -jar picard.jar Markduplicates l=unaligned_read_pair.sam O=output_duplicates.sam'},
                {data:'M=output_duplicate_report.txt REMOVE_DUPLICATES=true'},
            ]}
            /><br/>
            <li className="content_description">Options for Markduplicates</li>
            <OptionTable
                data={[
                    {   option:'I',
                        desc:'specify the SAM / BAM read file generated from FastqToSam'},
                    {   option:'O',
                        desc:'specify the output read file '},
                    {   option:'M',
                        desc:'specify the duplication metrics file'},
                    {   option:'REMOVE_DUPLICATES',
                        desc:'specify whether to output the duplicated reads'},
                ]}
            /><br />
            <div className="content_buttons_div">
                <Link to="/Gaap01"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap03"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap02;